var en_us = {
    values: {
        'reports approval': 'Reports Approval',
        'Error trying to save the approval settings': 'Error trying to save the approval settings: ',
        'Search for a report approval': 'Search for a report approval',

        // Table Header
        'Report Name': 'Report Name',
        'Schedule Name': 'Schedule Name',
        'Alarm Rule': 'Alarm Rule',
        Asset: 'Asset',
        Timespan: 'Timespan',
        'Data Status': 'Data Status',
        'Sending Status': 'Sending Status',

        'Check data': 'Check data',
        'Send report': 'Send report',

        // Check and Send Modal
        approvalListCheckDataMessage:
            'This action will load the Static Data Input in a new browser tab, with the reports Rig and Timespan. It will also record the date, time and responsible for checking the data in the Reports Approval.',
        approvalListUndoneAlertMessage: 'This action cannot be undone.',
        approvalListSendDataMessage:
            'This action will update the date, time, and responsible for sending of the report.',
        approvalListCheckDataTitle: 'Check Data',
        approvalListSendDataTitle: 'Attention!',
        confirmCheckDataButton: 'Go to data check',
        confirmSendDataButton: 'Send data',

        'Server local time': 'Server local time: ',
        Unchecked: 'Unchecked',
        'Dashboard not found': 'Dashboard not found',
        'Data checked on': 'Data checked on ',
        'Checked by': ' Checked by ',
        'Not sent': 'Not sent',
        'Last sent on': 'Last sent on ',
        'Sent by': ' Sent by '
    }
}

module.exports = en_us
